import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import moment from 'moment';
import wait_some_seconds from "nllib/src/common/wait_some_seconds";

import BaseMultipleEntitySelector003 from '../../../yinzhilv/base-multiple-entity-selector-0201/1.5.0/index.js';
import consumer_department_getStaffsAndExCus
    from "../../../../lib/data-service/haolv-default/consumer_department_getStaffsAndExCus";
import consumer_apply_applyJourneyCompanyStaffList
    from '../../../../lib/data-service/haolv-default/consumer_apply_applyJourneyCompanyStaffList'
import consumer_department_getStaffsAndExCusByUserIds
    from "../../../../lib/data-service/haolv-default/consumer_department_getStaffsAndExCusByUserIds";
import consumer_department_getStaffsAndCertificateByUserIds
    from '../../../../lib/data-service/haolv-default/consumer_department_getStaffsAndCertificateByUserIds'

export default {
    mixins: [
        BaseMultipleEntitySelector003,
    ],
    data() {
        return {
            init_parameter: {
                entity_define: {
                    property_name_for_id: `userId`,
                    property_name_for_name: `name`,
                    property_name_for_children: `children`,
                    property_name_for_parent_id: `parentId`,
                    property_name_for_order_index: `index`,
                    get_enable: (pParameter) => {
                        if (!pParameter) pParameter = {};
                        const __this = this;
                        if (__this.init_parameter.situation === '000') {
                            return true
                        }
                        const entity = pParameter.entity;
                        return entity.bookStatus === 1;
                    },
                    get_enable_false_msg(pParameter) {
                        if (!pParameter) pParameter = {};
                        const entity = pParameter.entity;
                        const msg = entity.nonBookableReason;
                        return msg;
                    },
                },

                dialog: {
                    title: `请选择出行人员`,
                    width: '1100px'
                },

                // 场景：
                // 000: 代客下单,
                // 100: pc端
                situation: `000`,
                maxNum: 0,
                businessType: '',

                table: {
                    column_list: [
                        {
                            prop: `name_001`,
                            label: `姓名`,
                            width: `160`,
                        },
                        {
                            prop: `unSensitiveCertificateValue`,
                            label: `证件号码`,
                            width: `160`,
                        },
                        {
                            prop: `unSensitivePhone`,
                            label: `联系方式`,
                            width: `160`,
                        },
                        {
                            prop: 'userTypeText',
                            label: `类型`,
                            width: `80`,
                        },
                    ],
                },

                btn_select_all: {
                    show: false,
                    // show: true,
                },

                btn_unselect_all: {
                    show: false,
                    // show: true,
                },

                get_pager_data(pParameter) {
                    if (!pParameter) pParameter = {};
                    const page_index = pParameter.page_index;
                    const page_size = pParameter.page_size;
                    const search_keyword = pParameter.search_keyword;

                    const __this = this;
                    const init_parameter = __this.init_parameter;
                    const situation = init_parameter.situation;
                    const businessType = init_parameter.businessType;

                    const __get_pager_data_parameter = init_parameter.get_pager_data_parameter || init_parameter.get_data_source_parameter;
                    let get_pager_data_parameter;
                    if (_.isFunction(__get_pager_data_parameter)) {
                        get_pager_data_parameter = __get_pager_data_parameter;
                    } else {
                        get_pager_data_parameter = function () {
                            return Q.resolve({});
                        };
                    }

                    return Q.when()
                        .then(function () {
                            return get_pager_data_parameter();
                        })
                        .then(function (p_001) {
                            let p_000 = {
                                currentPage: page_index,
                                pageSize: page_size,
                                key: search_keyword,
                            };
                            if (situation === '100') {
                                p_000.businessType = businessType;
                                p_000.keyword = search_keyword;
                            }

                            const p = extend({}, p_001, p_000);

                            const fn = situation === '000' ? consumer_department_getStaffsAndExCus : consumer_apply_applyJourneyCompanyStaffList;

                            return fn(p);
                        })
                        .then(function (data) {
                            const datas = data.datas;
                            const list = datas.list;
                            const page_index = datas.currPage;
                            const page_size = datas.pageSize;
                            const page_count = datas.totalPage;
                            const record_count = datas.totalCount;
                            const search_keyword = datas.key;

                            _.each(list, function (m) {
                                let name = `<div>${m.name}</div>`;
                                if (m.nonBookableReason) {
                                    name += `<div>${m.nonBookableReason}</div>`
                                }
                                m.name_001 = name
                            });

                            const pager_data = {
                                list,
                                page_index,
                                page_size,
                                page_count,
                                record_count,
                                search_keyword,
                            };
                            return Q.resolve({
                                pager_data,
                            });
                        })
                        .catch(function (ex) {
                            if (ex) {
                                const enable_log_error = !ex.disable_log_error;
                                if (enable_log_error) {
                                    console.error(ex);
                                    console.trace();
                                    if (ex.stack) {
                                        console.error(ex.stack);
                                    }
                                }
                            }
                            return Q.reject(ex);
                        })
                        ;
                },

                get_entity_list_by_id_list: (pParameter) => {
                    const __this = this;
                    if (!pParameter) pParameter = {};
                    const id_list = pParameter.id_list;
                    const property_name_for_id = pParameter.property_name_for_id;
                    const fn = __this.init_parameter.situation === '000' ? consumer_department_getStaffsAndExCusByUserIds({
                        userIds: id_list,
                    }) : consumer_department_getStaffsAndCertificateByUserIds({
                        userIds: id_list,
                    })

                    return Q.when()
                        .then(function () {
                            return fn
                        })
                        .then(function (data) {
                            const datas = data.datas;
                            const list = datas.list;
                            const entity_list = list;

                            return Q.resolve({
                                entity_list,
                            });
                        })
                        .catch(function (ex) {
                            if (ex) {
                                const enable_log_error = !ex.disable_log_error;
                                if (enable_log_error) {
                                    console.error(ex);
                                    console.trace();
                                    if (ex.stack) {
                                        console.error(ex.stack);
                                    }
                                }
                            }
                            return Q.reject(ex);
                        })
                        ;


                },
                btn_ok_click_event_handler() {
                    console.log(`__btn_ok_click_event_handler`);
                },

                btn_cancel_click_event_handler() {
                    console.log(`__btn_cancel_click_event_handler`);
                },

                get_pager_data_parameter: null,
            },
        }
    },
};
